import { imperial, MALE, metric } from "../../constans";

export const validateEmail = (email) => {
  return String(email)
    .toLowerCase()
    .match(
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    );
};

export function validatePassword(pw) {
  return pw.length >= 6
  /*return /[A-Z]/.test(pw) &&
    /[a-z]/.test(pw) &&
    /[0-9]/.test(pw) &&
    /[^A-Za-z0-9]/.test(pw) &&
    pw.length >= 6;*/

}

export function formatDate(date) {
  return `${date.getFullYear()}.${String(date.getMonth() + 1).padStart(2, '0')}.${String(date.getDate()).padStart(2, '0')}`;
}

export function getGender(genderCode) {
  return genderCode == MALE ? "Male" : "Female"
}

export function getUnit(unit) {
  switch (unit) {
    case metric:
      return "mm / cm"
    case imperial:
      return "feet / inch"
  }
}


export function formatMoney(value, maximumFractionDigits = 0) {
  const formatter = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    maximumFractionDigits: maximumFractionDigits
  })
  return formatter.format(value)
}
